export class ButtonClose extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = "✖︎";
  }
}

customElements.define("button-close", ButtonClose);
